<template>
    <div>
        <slot v-bind:scope="sharedScope"></slot>
    </div>
</template>

<script>

export default {
    name: 'AreaMapBlock',
    data() {
        let self = this;
        return {
            sharedScope: {
                currentPoiId: null,
                onMarkerClick(id) {
                    self.sharedScope.currentPoiId = id;
                },
                onMapClick() {
                    self.sharedScope.currentPoiId = null;
                },
                onPoiClick(id) {
                    if (self.sharedScope.currentPoiId === id) {
                        self.sharedScope.currentPoiId = null
                    } else {
                        self.sharedScope.currentPoiId = id;
                    }
                }
            }
        }
    }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/js/components/AreaMapBlock.vue